export const msalConfig = {
    auth: {
      clientId: "5ac5147f-41f7-4e24-8e9e-0927c1706467",
      authority: "https://login.microsoftonline.com/common", // ✅ Use common here!
      //authority: "https://login.microsoftonline.com/e4c790e0-7ef9-445e-8374-a2a846e9bf0a",
      //redirectUri: "http://localhost:3000" // THIS IS CRITICAL
      redirectUri: "https://white-field-0de53b10f.6.azurestaticapps.net/"
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false
    }
  };
  
  export const loginRequest = {
    scopes: ["openid", "profile", "email"]
  };
  